import React from "react";


const InnerHeading = ({ heading, text }) => {

    return (
        <>
            {/* <h1 className="bold text-center innerBigHeading mb-4"> {heading}</h1> */}
            {/* <h6 className="text-center innerHeading">{text}</h6> */}

        </>
    );
};

export default InnerHeading;
